import NykBasicCard from 'components/NykBasicCard/NykBasicCard.vue'

export default {
    name: 'DitRaaderumCalculatorResultCard',
    components: {
        NykBasicCard,
    },
    props: {
        labels: {
            type: Object,
            default: () => ({}),
        },
        result: {
            type: Object,
            default: null,
        },
        formatAmount: {
            type: Function,
            required: true,
        },
    },
}
